import React from "react";
import { Modal } from "antd";
import { PictureAsPdf } from "@mui/icons-material";

function GeneratingPdfModal({ visible, onClose, progress = 0 }) {
  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      footer={null}
      centered
      closable
      maskClosable={false}
      width={380}
      className="generating-modal"
    >
      <div className="generating-modal-content">
        <div className="generating-modal-icon">
          <PictureAsPdf />
        </div>
        <h3 className="generating-modal-title">Generating PDF</h3>
        <p className="generating-modal-description">
          Please wait while we prepare your document…
        </p>
        <div className="generating-modal-progress">
          <div
            className="generating-modal-progress-fill"
            style={{ width: `${progress}%` }}
          />
        </div>
        {typeof progress === "number" && (
          <span className="generating-modal-percent">{progress}%</span>
        )}
      </div>
    </Modal>
  );
}

export default GeneratingPdfModal;
